export default __webpack_public_path__ + "static/media/circle.5bfc9d8c.svg";